
















































import Vue from 'vue';
import { Component, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import DiligenceAssessmentComponent from "./components/AssessmentForm.vue";
import ValidationMessageComponent from '@/components/common/ValidationMessage/ValidationMessage.vue';
import { AssessmentForm } from '@/entities';
import { Locales } from "@/i18n/locales";

const namespace: string = "assessmentForm";
@Component({
  components: {
    DiligenceAssessmentComponent,
    ValidationMessageComponent
  }
})
export default class InternalReviewWorkspaceComponent extends Vue {

  @State(namespace) form!: AssessmentForm;
  @Action("getData", { namespace }) getData: any;
  @Action("getTemplate", { namespace }) getTemplate: any;
  @Action("updateMainTab", { namespace }) updateMainTab: any;
  @Action("updateLanguage", { namespace }) updateLanguage: any;
  @Action("saveReviewData", { namespace }) saveReviewData: any;
  @Getter("_appUser", { namespace: "RootApp" }) _username!: string;
  @Getter("appSectionTemplate", { namespace }) appSectionTemplate: any;
  @Getter("appSection", { namespace }) appSectionData: any;
  @Action("getDataByApplication", { namespace }) getDataByApplication: any;
  @Action("getApplicationSection", { namespace }) getApplication: any;
  @Action("dirtySaveDiligence", { namespace }) dirtySaveDiligence: any;

  isDirty: boolean = false;
  update: number = 0;
  isSubmitted = false;
  reviewId: number = 0;
  selectedTopMenu: string = "dueDiligence";
  readOnly: boolean =false;
  completedBy: string;
  entity: string;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;
  /** open a read only view of application in new tab */
  openApplication(applicationId) {
    if (this.entity == "ConceptNote") {
      let routeData = this.$router.resolve({
        name: "viewConceptNote",
        params: { conceptNoteId: applicationId, section: 'technicalApplication' }
      });
      window.open(routeData.href, "_blank");
    }
    else {
      let routeData = this.$router.resolve({
        name: "viewApplication",
        params: { appId: applicationId, section: 'technicalApplication' }
      });
      window.open(routeData.href, "_blank");
    }
  }

  /** update the selected key on top menu selection */
  topMenuChanged(key) {
    this.selectedTopMenu = key;
  }

  /** set is-dirty flag  */
  setDirtyFlag(flag) {
    this.isDirty = flag;
  }

  download(){
   this.$services.dueDeligancePdf.print(
     this.form.dueDeliganceAssessment.templates.properties,
     this.form.dueDeliganceAssessment.data,
     this.appSummary,
     this.options);
  }

  back(appId) {
    this.saveDirty(() => {
      this.$router.push({
        name: "internalReviewSummary",
        params: { applicationId: appId, entity: this.entity },
      });
    });
  }
  /** save comments */
  saveComment(e)
  {
    this.saveReview('save')
  }
  /** save due diligence assesssment */
  saveReview(context: string) {
    this.saveReviewData({
        data: this.form.dueDeliganceAssessment.data,
        id: this.form.internalReviewId,
        context,
        entity: this.entity
      }).then((resp: any) => {
        if (resp) {
          this.setDirtyFlag(false);
        }
      })
  }

  saveDirty(callback: any) {
    const self = this;
    if (this.isDirty) {
      let datum = {
        id: self.form.internalReviewId,
        data: self.form.dueDeliganceAssessment.data,
        context: "dueDiligence"
      };
      this.dirtySaveDiligence(datum).then(res => {
        if (res.Result === "OK") {
          callback();
        }
      });
    } else {
      callback();
    }
  }

  validationMessageClicked(val: any) {
    if (val.SubSectionKey) {
      this.$router.push({
        name: "internalReview",
        params: { applicationId: this.appSummary.ApplicationId.toString() },    
        hash: `#${val.SubSectionKey}`
      }).catch(() => {})
    }
    this.form.dueDeliganceAssessment.showValidationDialog = false;
    this.form.dueDeliganceAssessment.validationMessages = [];
  }

  validationMessageClosed() {
    this.form.dueDeliganceAssessment.showValidationDialog = false;
    this.form.dueDeliganceAssessment.validationMessages = [];
  }

  /** date conversion */
  formattedDate() {
    let date: any;
    if (this.form.dueDeliganceAssessment.data.auditInfo) {
      date = this.form.dueDeliganceAssessment.data.auditInfo.updatedDate
        ? this.form.dueDeliganceAssessment.data.auditInfo.updatedDate
        : new Date();
    } else {
      date = new Date();
    }
    return this.$services.format.formatUTC(date);
  }

  /*submitReview(context: string) {
    this.submitReviewData({
        data: this.form.dueDeliganceAssessment.data,
        id: this.form.internalReviewId,
        context
      }).then((data) => {
            if(data) {
                const key: any = 'reviewSubmitted';
                this.$router.push({
                    name: "genericNotification",
                    query: { msgId: key }
                });
            }          
        });
  }*/

  get options() {
    return {
      userInfo: {
        userName: this._username
      },
      modifiedAt: this.formattedDate(),
      insightData: this.appSectionData,
      insightSchema: this.appSectionTemplate,
      downloadAction: this.$services.document.download,
      completedBy:this.completedBy,
      readOnly:false,
      locale: this.defaultLocale
    };
  }

  get appSummary() {
    return this.form.applicationSection.appHeader;
  }

  get saveStatus() {
    if (this.form.reviewHeader.DDReviewSubmitted && this.form.reviewHeader.DDReviewSubmitted == 1) {
      return false;
    } else {
      return true;
    }
  }

  /** watch methods */
  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(changedRoute: any) {
    if(changedRoute && changedRoute.name === 'internalReview') {
      if(this.$route.hash)
        this.form.dueDeliganceAssessment.selectedKey = this.$route.hash.substr(1);
      else
        window.location.hash = `#${this.form.dueDeliganceAssessment.selectedKey}`;
      
      if (this.$route.params && this.$route.params.applicationId && this.$route.params.entity) {
        const id = parseInt(this.$route.params.applicationId);
        //let entity = this.$route.params.entity;
        this.entity = this.$route.params.entity;

        if (!this.form || !this.form.reviewHeader) {
          this.getDataByApplication({id: id, entity: this.entity});
          this.getApplication({id: id, entity: this.entity});
        }
      }
      this.update += 1;
      // this.$services.application.getApplicationData(this.form.dueDeliganceAssessment.data.applicationId).then((data) => {
      //   this.appSummary = data;
      // });
    }
  }
  
  @Watch("selectedTopMenu")
  onMenuChanges(value: any) {
    this.updateMainTab(value);
  }

  @Watch("$vuetify.lang.current")
  onPropertyChanges(value: any, oldvalue: any) {
    this.updateLanguage(value);
  }
}
